import { createSlice } from "@reduxjs/toolkit";
import { Site } from "@src/@types/SitesTypes";
import {  PlanType, Subscription, UserAccount } from "@src/@types/UserAccount";



const INITIAL_STARTE: UserAccount = {
    email: "",
    accounts: []
}
const INITIAL_STATE_SUBSCRIPTION:Subscription = {
    planCode: "0",
    planName: "Trial",
    planType: PlanType.FREE,
    planDescription: "",
    statusLabel: "",
    active: true,
    status: "TRIAL",
    daysUntilRenewal: 0,
    expirationDate: ""
}


export function authUserAccount(state = INITIAL_STARTE, action: { type: string; userAccount: UserAccount; }) {
    if (action.type === 'UPDATE_USER') {
        state = action.userAccount
    }
    return state;
}

const restoreUser = (): UserAccount => {
    const userAccount = window.localStorage.getItem("userAccount");
    return userAccount ? JSON.parse(userAccount) : INITIAL_STARTE;
}

const restoreIsToSaveToStorage = (): boolean => {
    const savetoStorageUserAccount = window.localStorage.getItem("saveToStorageUserAccount");
    return savetoStorageUserAccount ? JSON.parse(savetoStorageUserAccount) : false;
}

const getSitesFromAccount = () => {
    let sites: Site[] = []
    let account = getActiveAccount();
    if (account && account.licenses) {
        account.licenses.forEach((s, index) => {
            let site: Site = {
                domain: s.domain,
                enabled: s.enabled
            };
            sites.push(site);
        })
    }
    return sites;
}


const getSubscriptionFromAccount = () => {
    let account = getActiveAccount();
    if (account && account.subscription) {
        return account.subscription;
    }
    return INITIAL_STATE_SUBSCRIPTION;
}
// implementar quando definir negocio sobre escolha de conta 1
const getActiveAccount = () => {
    const userAccount = restoreUser();
    let account = userAccount.accounts;
    if (account && account[0]) {
        return account[0]
    }
    return undefined;
}


export const userAccountSlice = createSlice({
    name: "userAccount",
    initialState: {
        userAccount: restoreUser(),
        saveToStorage: restoreIsToSaveToStorage(),
        activeAccount: getActiveAccount(),
        sites: getSitesFromAccount(),
        subscription : getSubscriptionFromAccount(),
        isOnLoading: false
    },
    reducers: {
        handleUserAccount: (state, action) => {
            state.userAccount = action.payload;
            console.log(state.userAccount)
            console.log('handleruseraccount reducer')
            window.localStorage.setItem("userAccount", JSON.stringify(action.payload));
            state.sites = getSitesFromAccount();
            state.subscription = getSubscriptionFromAccount();
        },
        handleSaveToStorage: (state, action) => {
            state.saveToStorage = action.payload;
            window.localStorage.setItem("saveToStorageUserAccount", JSON.stringify(action.payload));
        },
        handleRemoveAccount: () => {
            console.log("Cleaning userAccount from redux");
            window.localStorage.removeItem("userAccount");
        },
        handleSetActiveAccount: (state, action) => {
            state.activeAccount = action.payload;
            if (action.payload?.licenses) {
                state.sites = action.payload.licenses.map((s: Site) => ({
                    domain: s.domain,
                    enabled: s.enabled
                }));
            }
            if (action.payload?.subscription) {
                state.subscription = action.payload.subscription;
            }
        },
        handleSetOnLoading: (state, action) => { // implementar quando definir negocio sobre escolha de conta 2
            state.isOnLoading = action.payload;
        }
    }
})
export const {
    handleUserAccount,
    handleSaveToStorage,
    handleRemoveAccount,
    handleSetActiveAccount,
    handleSetOnLoading
} = userAccountSlice.actions;

export default userAccountSlice.reducer;
